module.exports = __webpack_public_path__ + "img/banner-history.b7c21bd1.jpg";